import { __rest } from "tslib";
import React, { forwardRef, useLayoutEffect, useRef } from 'react';
import { createReactWrapper } from '../common/PrefixUtils';
import { handleForwardRef } from '../common/RefUtils';
import { addExtraProps } from '../common/utils/AddExtraProps';
export const Autocomplete = forwardRef((_a, ref) => {
    var { value, noOptionsText, onChange, onInput, onClearClick, filterFunction, disableFiltering, label, children, start, renderChips: renderChipsWithoutSlot, helperText, fullWidth } = _a, props = __rest(_a, ["value", "noOptionsText", "onChange", "onInput", "onClearClick", "filterFunction", "disableFiltering", "label", "children", "start", "renderChips", "helperText", "fullWidth"]);
    const autocompleteRef = useRef();
    const handledRef = handleForwardRef(autocompleteRef, ref);
    const handleInput = (event) => {
        onInput === null || onInput === void 0 ? void 0 : onInput(event);
    };
    const handleChange = (event) => {
        onChange === null || onChange === void 0 ? void 0 : onChange(event);
    };
    const handleOnClearClick = (event) => {
        onClearClick === null || onClearClick === void 0 ? void 0 : onClearClick(event);
    };
    const renderChips = renderChipsWithoutSlot
        ? renderChipsWithoutSlot.map((chip) => {
            return React.cloneElement(chip, {
                slot: 'chips',
                closable: true,
                closeLabel: `Remove option ${chip.props.children}`,
            });
        })
        : [];
    useLayoutEffect(() => {
        var _a;
        (_a = autocompleteRef.current) === null || _a === void 0 ? void 0 : _a.addEventListener('change', handleChange);
        return () => {
            var _a;
            (_a = autocompleteRef.current) === null || _a === void 0 ? void 0 : _a.removeEventListener('change', handleChange);
        };
    }, [autocompleteRef, onChange]);
    useLayoutEffect(() => {
        var _a;
        (_a = autocompleteRef.current) === null || _a === void 0 ? void 0 : _a.addEventListener('input', handleInput);
        return () => {
            var _a;
            (_a = autocompleteRef.current) === null || _a === void 0 ? void 0 : _a.removeEventListener('input', handleInput);
        };
    }, [autocompleteRef, onInput]);
    useLayoutEffect(() => {
        var _a;
        (_a = autocompleteRef.current) === null || _a === void 0 ? void 0 : _a.addEventListener('clear-click', handleOnClearClick);
        return () => {
            var _a;
            (_a = autocompleteRef.current) === null || _a === void 0 ? void 0 : _a.removeEventListener('clear-click', handleOnClearClick);
        };
    }, [autocompleteRef, onClearClick]);
    useLayoutEffect(() => {
        if (autocompleteRef.current && filterFunction) {
            autocompleteRef.current.filterFunction = filterFunction;
        }
    }, [autocompleteRef, filterFunction]);
    return createReactWrapper({
        tagName: 'chameleon-autocomplete',
        props: Object.assign({ ref: handledRef, 'no-options-text': noOptionsText, 'disable-filtering': disableFiltering, 'full-width': fullWidth, value }, props),
        children: (React.createElement(React.Fragment, null,
            label && addExtraProps(label, { slot: 'label' }),
            renderChips && renderChips,
            start && addExtraProps(start, { slot: 'start' }),
            helperText && addExtraProps(helperText, { slot: 'helper-text' }),
            children)),
    });
});
